import { getPostListingValidationSchema } from './getValidationSchema';
import { profileFormFields } from './profileFields';
import { buyPackageLeadFormFields } from './buyPackageLeadFields';
// Bayut regional sites share the same listing-type taxonomy as Bayut KSA, so the land
// property-type check is reused. Exposed on tenantData so the listing drawer can hide
// beds/baths rows for land listings.
import { isLandPropertyType } from '../../bayut/data/listing-form-data';

// Help & Support redirection targets for Bayut Oman. Overrides the common (null) defaults
// so the Help & Support cards link to the Oman Help Center categories instead of resolving
// to a relative `/null` path.
const helpAndSupportUrls = {
  aboutProfolio: {
    en: 'https://help.bayut.om/hc/en-us/categories/25586449748626',
    ar: 'https://help.bayut.om/hc/ar/categories/25617035824658',
  },
  aboutRega: {
    en: null,
    ar: null,
  },
  faqs: {
    en: 'https://help.bayut.om/hc/en-us/categories/25586434807058',
    ar: 'https://help.bayut.om/hc/ar/categories/25617052232850',
  },
};

export default {
  getPostListingValidationSchema,
  profileFormFields,
  buyPackageLeadFormFields,
  isLandPropertyType,
  helpAndSupportUrls,
};
